<template>
  <div>
    <v-snackbar
      v-model="dialog.snackbar"
      top
      right
      color="#00ACC1">
      <span class="body-1 font-weight-light white--text"
        v-html="message.success">
      </span>

      <template v-slot:action="{ attrs }">
        <v-btn
          class="body-1 font-weight-bold text-capitalize"
          color="white"
          icon
          v-bind="attrs"
          @click="dialog.snackbar = false">
          <v-icon>mdi-close-circle-outline</v-icon>
        </v-btn>
      </template>
    </v-snackbar>

    <v-dialog v-model="dialog.form"
      width="500"
      persistent
      scrollable>
      <v-card 
        class="border-radius pa-2">
        <v-card-title class="d-flex align-center py-0 px-3 text-right">
          <v-avatar size="35">
            <v-img
              contain
              width="30"
              height="30"
              alt="VENOM"
              :src="require('@/assets/logo/venom.png')">
              <template v-slot:placeholder>
                <v-row
                  class="fill-height"
                  align="center"
                  justify="center">
                  <v-progress-circular 
                    indeterminate 
                    color="#00ACC1">
                  </v-progress-circular>
                </v-row>
              </template>
            </v-img>
          </v-avatar>

          <span class="text-capitalize mt-1 ml-1">
            Data Absensi {{ selected.attendance }}
          </span>

          <v-spacer/>

          <v-btn
            fab
            x-small
            elevation="0"
            color="red"
            class="white--text"
            @click="reset()">
            <v-icon>mdi-close-circle-outline</v-icon>
          </v-btn>
        </v-card-title>
        
        <v-divider class="mx-4 my-3"/>

        <v-card-text class="mt-4">
          <ValidationObserver ref="form">
            <v-form>
              <p v-if="selected.attendance === 'hadir' || selected.attendance === 'pulang'"
                class="body-1 font-weight-light text-first">
                Silahkan pilih petugas, kemudian klik tombol simpan untuk menyimpan data.
              </p>

              <p v-else
                class="body-1 font-weight-light text-first">
                Silahkan pilih petugas dan berikan alasan kenapa ijin, kemudian klik tombol simpan untuk menyimpan data.
              </p>

              <ValidationProvider name="user_id" rules="required" v-slot="{ errors }" v-if="selected.attendance !== 'pulang'">
                <p class="mb-2">
                  <span class="red--text">*</span>
                  Petugas
                </p>

                <v-autocomplete
                  v-on:keyup.enter="save()"
                  :style="rps === 'xs' ? '' : 'width: 60%;'"
                  dense
                  outlined
                  color="#00ACC1"
                  placeholder="Ex. John Doe"
                  :items="list.user"
                  item-text="name"
                  item-value="id"
                  item-color="cyan darken-1"
                  v-model="form.user_id"
                  :error-messages="errors"
                  require>
                  <template v-slot:selection="data">
                    <v-avatar left size="25">
                      <v-img 
                        :src="data.item.image_url !== '' ? data.item.image_url : require('@/assets/image/member-default.jpg')">
                        <template v-slot:placeholder>
                          <v-row
                            class="fill-height"
                            align="center"
                            justify="center">
                            <v-progress-circular 
                              indeterminate 
                              color="#00ACC1">
                            </v-progress-circular>
                          </v-row>
                        </template>
                      </v-img>
                    </v-avatar>

                    <span class="ml-2">
                      {{ data.item.name }}
                    </span>
                  </template>

                  <template v-slot:item="data">
                    <v-list-item-avatar>
                      <v-img 
                        :src="data.item.image_url !== '' ? data.item.image_url : require('@/assets/image/member-default.jpg')">
                        <template v-slot:placeholder>
                          <v-row
                            class="fill-height"
                            align="center"
                            justify="center">
                            <v-progress-circular 
                              indeterminate 
                              color="#00ACC1">
                            </v-progress-circular>
                          </v-row>
                        </template>
                      </v-img>
                    </v-list-item-avatar>

                    <v-list-item-content>
                      <v-list-item-title class="text-first text-capitalize">
                        {{ data.item.name }}
                      </v-list-item-title>
                      
                      <v-list-item-subtitle class="font-weight-light text-second text-capitalize">
                        {{ data.item.position }}
                      </v-list-item-subtitle>
                    </v-list-item-content>
                  </template>
                </v-autocomplete>
              </ValidationProvider>

              <ValidationProvider name="user_id" rules="required" v-slot="{ errors }" v-if="selected.attendance === 'pulang'">
                <p class="mb-2">
                  <span class="red--text">*</span>
                  Petugas
                </p>

                <v-autocomplete
                  v-on:keyup.enter="save()"
                  :style="rps === 'xs' ? '' : 'width: 60%;'"
                  dense
                  outlined
                  color="#00ACC1"
                  placeholder="Ex. John Doe"
                  :items="list.user"
                  item-text="user_name"
                  item-value="id"
                  item-color="cyan darken-1"
                  v-model="form.id"
                  :error-messages="errors"
                  require>
                  <template v-slot:selection="data">
                    <v-avatar left size="25">
                      <v-img 
                        :src="data.item.user_image_url !== '' ? data.item.user_image_url : require('@/assets/image/member-default.jpg')">
                        <template v-slot:placeholder>
                          <v-row
                            class="fill-height"
                            align="center"
                            justify="center">
                            <v-progress-circular 
                              indeterminate 
                              color="#00ACC1">
                            </v-progress-circular>
                          </v-row>
                        </template>
                      </v-img>
                    </v-avatar>

                    <span class="ml-2">
                      {{ data.item.user_name }}
                    </span>
                  </template>

                  <template v-slot:item="data">
                    <v-list-item-avatar>
                      <v-img 
                        :src="data.item.user_image_url !== '' ? data.item.user_image_url : require('@/assets/image/member-default.jpg')">
                        <template v-slot:placeholder>
                          <v-row
                            class="fill-height"
                            align="center"
                            justify="center">
                            <v-progress-circular 
                              indeterminate 
                              color="#00ACC1">
                            </v-progress-circular>
                          </v-row>
                        </template>
                      </v-img>
                    </v-list-item-avatar>

                    <v-list-item-content>
                      <v-list-item-title class="text-first text-capitalize">
                        {{ data.item.user_name }}
                      </v-list-item-title>
                      
                      <v-list-item-subtitle class="font-weight-light text-second text-capitalize">
                        {{ data.item.start_datetime | datetime }}
                      </v-list-item-subtitle>
                    </v-list-item-content>
                  </template>
                </v-autocomplete>
              </ValidationProvider>

              <v-row>
                <v-col cols="12" md="7" class="py-0">
                  <div>
                    <p class="mb-2">
                      <span class="red--text">*</span>
                      Tanggal
                    </p>

                    <v-menu
                      ref="date"
                      min-width="290px"
                      max-width="290px"
                      transition="scale-transition"
                      offset-y
                      :nudge-right="40"
                      :close-on-content-click="false"
                      v-model="picker.date">
                      <template v-slot:activator="{ on }">
                        <ValidationProvider name="date" rules="required" v-slot="{ errors }">
                          <v-text-field
                            v-model="form.date"
                            readonly
                            outlined
                            dense
                            color="#00ACC1"
                            placeholder="Ex. 2021-08-01"
                            clearable
                            @click:clear="form.date = ''; form.time = '';"
                            v-on="on"
                            :error-messages="errors"
                            require>
                          </v-text-field>
                        </ValidationProvider>
                      </template>
                      
                      <v-date-picker 
                        color="#00ACC1"
                        v-model="form.date"
                        @input="picker.date = false"
                        v-on:change="form.time = ''">
                      </v-date-picker>
                    </v-menu>
                  </div>
                </v-col>

                <v-col cols="12" md="5" class="py-0" v-if="selected.attendance !== 'ijin'">
                  <div>
                    <p class="mb-2">
                      <span class="red--text">*</span>
                      Jam
                    </p>

                    <v-menu
                      ref="time"
                      v-model="picker.time"
                      :close-on-content-click="false"
                      :nudge-right="40"
                      :return-value.sync="form.time"
                      transition="scale-transition"
                      offset-y
                      max-width="290px"
                      min-width="290px">
                      <template v-slot:activator="{ on }">
                        <ValidationProvider name="time" rules="required" v-slot="{ errors }">                   
                          <v-text-field
                            v-model="form.time"
                            readonly
                            outlined
                            dense
                            color="#00ACC1"
                            placeholder="Ex. 08:00"
                            clearable
                            :disabled="form.date.length < 1"
                            @click:clear="form.time = ''"
                            v-on="on"
                            :error-messages="errors"
                            require>
                          </v-text-field>
                        </ValidationProvider>
                      </template>

                      <v-time-picker 
                        v-if="picker.time"
                        color="#00ACC1"
                        v-model="form.time"
                        full-width
                        format="24hr"
                        @click:minute="$refs.time.save(form.time)">
                      </v-time-picker>
                    </v-menu>
                  </div>
                </v-col>
              </v-row>

              <ValidationProvider name="address" rules="required" v-slot="{ errors }" v-if="selected.attendance === 'ijin'">
                <p class="mb-2">
                  <span class="red--text">*</span>
                  Alasan Ijin
                </p>

                <v-textarea
                  v-on:keyup.enter="save()"
                  outlined
                  dense
                  placeholder="Ex. Saya sedang sakit."
                  rows="5"
                  color="#00ACC1"
                  v-model="form.leave_reason"
                  :error-messages="errors"
                  require>
                </v-textarea>
              </ValidationProvider>
            </v-form>
          </ValidationObserver>
        </v-card-text>

        <v-alert v-if="message.error.length > 0"
          class="mx-6"
          type="error" 
          dense
          text 
          prominent>
          {{ message.error }}
        </v-alert>

        <v-divider class="mx-4 my-3"/>

        <v-card-actions>
          <v-spacer/>

          <v-btn
            color="#00ACC1"
            elevation="0"
            class="body-2 font-weight-bold text-capitalize white--text"
            :disabled="process.form"
            :loading="process.form"
            v-on:keyup.enter="save()"
            @click="save()">
            <v-icon small class="mr-1">mdi-check-bold</v-icon>
            Simpan
          </v-btn>

          <v-btn
            outlined
            class="body-2 font-weight-bold text-capitalize red--text"
            :disabled="process.form"
            @click="reset()">
            <v-icon color="red" small class="mr-1">mdi-close-circle</v-icon>
            Batal
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialog.filter"
      width="550"
      persistent
      scrollable>
      <v-card 
        class="border-radius pa-2">
        <v-card-title class="d-flex align-center py-0 px-3 text-right">
          <v-avatar size="35">
            <v-img
              contain
              width="30"
              height="30"
              alt="VENOM"
              :src="require('@/assets/logo/venom.png')">
              <template v-slot:placeholder>
                <v-row
                  class="fill-height"
                  align="center"
                  justify="center">
                  <v-progress-circular 
                    indeterminate 
                    color="#00ACC1">
                  </v-progress-circular>
                </v-row>
              </template>
            </v-img>
          </v-avatar>

          <span class="text-capitalize mt-1 ml-1">
            Filter Data
          </span>

          <v-spacer/>

          <v-btn
            fab
            x-small
            elevation="0"
            color="red"
            class="white--text"
            @click="dialog.filter = false">
            <v-icon>mdi-close-circle-outline</v-icon>
          </v-btn>
        </v-card-title>
        
        <v-divider class="mx-4 my-3"/>

        <v-card-text>
          <v-form>
            <v-row>
              <v-col cols="12" md="8">
                <div>
                  <p class="mb-2">
                    Pilih Filter Range
                  </p>
                  
                  <v-select
                    :items="menu_filter"
                    placeholder="Pilih Status Kunjungan"
                    outlined
                    dense
                    color="#00ACC1"
                    item-text="text"
                    item-value="value"
                    item-color="cyan darken-1"
                    hide-details
                    v-model="selected.menu_filter">
                  </v-select>
                </div>
              </v-col>
            </v-row>

            <p class="body-1 font-weight-bold text-first mt-3 mb-1">
              Filter Tanggal & Waktu
              <span v-if="selected.menu_filter === 0">
                Datang (Lebih Dari)
              </span>

              <span v-else>
                (Lebih Dari)
              </span>
            </p>

            <v-row>
              <v-col cols="12" md="5">
                <div>
                  <p class="mb-2">
                    Tanggal
                  </p>
                  
                  <v-menu
                    ref="start"
                    min-width="290px"
                    max-width="290px"
                    transition="scale-transition"
                    offset-y
                    :nudge-right="40"
                    :close-on-content-click="false"
                    v-model="search.picker.date.start">
                    <template v-slot:activator="{ on }">
                      <v-text-field
                        v-model="search.filter.date.start"
                        readonly
                        outlined
                        dense
                        color="#00ACC1"
                        placeholder="Pilih Tanggal"
                        hide-details
                        clearable
                        @click:clear="search.filter.date.start = ''; search.filter.start_time = ''; search.filter.date.end = ''; search.filter.end_time = '';"
                        v-on="on">
                      </v-text-field>
                    </template>
                    
                    <v-date-picker 
                      color="#00ACC1"
                      v-model="search.filter.date.start"
                      @input="search.picker.date.start = false"
                      v-on:change="search.filter.start_time = ''; search.filter.date.end = ''; search.filter.end_time = '';">
                    </v-date-picker>
                  </v-menu>
                </div>
              </v-col>

              <v-col cols="12" md="5">
                <div>
                  <p class="mb-2">
                    Waktu
                  </p>

                  <v-menu
                    ref="starttime"
                    v-model="search.picker.start_time"
                    :close-on-content-click="false"
                    :nudge-right="40"
                    :return-value.sync="search.filter.start_time"
                    transition="scale-transition"
                    offset-y
                    max-width="290px"
                    min-width="290px">
                    <template v-slot:activator="{ on }">                
                      <v-text-field
                        v-model="search.filter.start_time"
                        readonly
                        outlined
                        dense
                        color="#00ACC1"
                        placeholder="Ex. 08:00"
                        hide-details
                        clearable
                        :disabled="search.filter.date.start === '' || search.filter.date.start === null"
                        @click:clear="search.filter.start_time = ''"
                        v-on="on">
                      </v-text-field>
                    </template>

                    <v-time-picker 
                      v-if="search.picker.start_time"
                      color="#00ACC1"
                      v-model="search.filter.start_time"
                      full-width
                      format="24hr"
                      @click:minute="$refs.starttime.save(search.filter.start_time)">
                    </v-time-picker>
                  </v-menu>
                </div>
              </v-col>
            </v-row>

            <p class="body-1 font-weight-bold text-first mt-3 mb-1">
              Filter Tanggal & Waktu
              <span v-if="selected.menu_filter === 0">
                Pulang (Kurang Dari)
              </span>

              <span v-else>
                (Kurang Dari)
              </span>
            </p>

            <v-row>
              <v-col cols="12" md="5">
                <div>
                  <p class="mb-2">
                    Tanggal
                  </p>
                  
                  <v-menu
                    ref="end"
                    min-width="290px"
                    max-width="290px"
                    transition="scale-transition"
                    offset-y
                    :nudge-right="40"
                    :close-on-content-click="false"
                    v-model="search.picker.date.end">
                    <template v-slot:activator="{ on }">
                      <v-text-field
                        v-model="search.filter.date.end"
                        readonly
                        outlined
                        dense
                        color="#00ACC1"
                        placeholder="Pilih Tanggal"
                        hide-details
                        clearable
                        @click:clear="search.filter.date.end = ''; search.filter.end_time = '';"
                        v-on="on">
                      </v-text-field>
                    </template>
                    
                    <v-date-picker 
                      color="#00ACC1"
                      v-model="search.filter.date.end"
                      :min="search.filter.date.start"
                      @input="search.picker.date.end = false"
                      v-on:change="search.filter.end_time = ''">
                    </v-date-picker>
                  </v-menu>
                </div>
              </v-col>
              
              <v-col cols="12" md="5">
                <div>
                  <p class="mb-2">
                    Waktu
                  </p>

                  <v-menu
                    ref="endtime"
                    v-model="search.picker.end_time"
                    :close-on-content-click="false"
                    :nudge-right="40"
                    :return-value.sync="search.filter.end_time"
                    transition="scale-transition"
                    offset-y
                    max-width="290px"
                    min-width="290px">
                    <template v-slot:activator="{ on }">                
                      <v-text-field
                        v-model="search.filter.end_time"
                        readonly
                        outlined
                        dense
                        color="#00ACC1"
                        placeholder="Ex. 08:00"
                        hide-details
                        clearable
                        :disabled="search.filter.date.end === '' || search.filter.date.end === null"
                        @click:clear="search.filter.end_time = ''"
                        v-on="on">
                      </v-text-field>
                    </template>

                    <v-time-picker 
                      v-if="search.picker.end_time"
                      color="#00ACC1"
                      v-model="search.filter.end_time"
                      full-width
                      format="24hr"
                      @click:minute="$refs.endtime.save(search.filter.end_time)">
                    </v-time-picker>
                  </v-menu>
                </div>
              </v-col>
            </v-row>
          </v-form>
        </v-card-text>

        <v-divider class="mx-4 my-3"/>

        <v-card-actions>
          <v-spacer/>

          <v-btn
            color="#00ACC1"
            elevation="0"
            class="body-2 font-weight-bold text-capitalize white--text"
            @click="dialog.filter = false; fetch();">
            <v-icon small class="mr-1">mdi-check-bold</v-icon>
            Filter
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialog.attachment"
      width="1000"
      persistent
      scrollable>
      <v-card 
        class="border-radius pa-2">
        <v-card-title class="d-flex align-center py-0 px-3 text-right">
          <v-avatar size="35">
            <v-img
              contain
              width="30"
              height="30"
              alt="VENOM"
              :src="require('@/assets/logo/venom.png')">
              <template v-slot:placeholder>
                <v-row
                  class="fill-height"
                  align="center"
                  justify="center">
                  <v-progress-circular 
                    indeterminate 
                    color="#00ACC1">
                  </v-progress-circular>
                </v-row>
              </template>
            </v-img>
          </v-avatar>

          <span class="text-capitalize mt-1 ml-1">
            Lampiran
          </span>

          <v-spacer/>

          <v-btn
            fab
            x-small
            elevation="0"
            color="red"
            class="white--text"
            @click="dialog.attachment = false">
            <v-icon>mdi-close-circle-outline</v-icon>
          </v-btn>
        </v-card-title>
        
        <v-divider class="mx-4 my-3"/>

        <div class="px-5 mb-3">
          <v-tabs
            v-model="selected.menu"
            background-color="transparent"
            color="#00ACC1"
            dense
            grow
            class="d-flex justify-start">
            <v-tab
              v-for="(item, index) in menu"
              :key="index"
              class="px-0 mx-1"
              style="min-width: 50px; max-width: 50px;">
              <span class="body-2 text-capitalize" :class="selected.menu === index ? 'font-weight-bold' : 'text-third'">
                {{ item }}
              </span>
            </v-tab>
          </v-tabs>
        </div>

        <v-card-text class="mt-4">
          <div v-if="selected.menu < 1">
            <v-img alt="VENOM"
              contain
              :src="selected.detail.start_image_url">
              <template v-slot:placeholder>
                <v-row
                  class="fill-height"
                  align="center"
                  justify="center">
                  <v-progress-circular 
                    indeterminate 
                    color="#00ACC1">
                  </v-progress-circular>
                </v-row>
              </template>
            </v-img>
          </div>

          <div v-else>
            <div :class="selected.detail.end_image_url === '' ? 'py-16 my-16' : ''">
              <v-img alt="VENOM"
                contain
                :width="selected.detail.end_image_url === '' ? '100%' : ''"
                :height="selected.detail.end_image_url === '' ? '150' : ''"
                :src="selected.detail.end_image_url === '' ? require('@/assets/image/empty.png') : selected.detail.end_image_url">
                <template v-slot:placeholder>
                  <v-row
                    class="fill-height"
                    align="center"
                    justify="center">
                    <v-progress-circular 
                      indeterminate 
                      color="#00ACC1">
                    </v-progress-circular>
                  </v-row>
                </template>
              </v-img>

              <p v-if="selected.detail.end_image_url === ''"
                class="title text-center mt-10">
                Belum absen pulang !!!
              </p>
            </div>
          </div>
        </v-card-text>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialog.location"
      width="1000"
      persistent
      scrollable>
      <v-card 
        class="border-radius pa-2">
        <v-card-title class="d-flex align-center py-0 px-3 text-right">
          <v-avatar size="35">
            <v-img
              contain
              width="30"
              height="30"
              alt="VENOM"
              :src="require('@/assets/logo/venom.png')">
              <template v-slot:placeholder>
                <v-row
                  class="fill-height"
                  align="center"
                  justify="center">
                  <v-progress-circular 
                    indeterminate 
                    color="#00ACC1">
                  </v-progress-circular>
                </v-row>
              </template>
            </v-img>
          </v-avatar>

          <span class="text-capitalize mt-1 ml-1">
            Lokasi
          </span>

          <v-spacer/>

          <v-btn
            fab
            x-small
            elevation="0"
            color="red"
            class="white--text"
            @click="dialog.location = false">
            <v-icon>mdi-close-circle-outline</v-icon>
          </v-btn>
        </v-card-title>
        
        <v-divider class="mx-4 my-3"/>

        <div class="px-5 mb-3">
          <v-tabs
            v-model="selected.menu"
            background-color="transparent"
            color="#00ACC1"
            dense
            grow
            class="d-flex justify-start">
            <v-tab
              v-for="(item, index) in menu"
              :key="index"
              class="px-0 mx-1"
              style="min-width: 50px; max-width: 50px;">
              <span class="body-2 text-capitalize" :class="selected.menu === index ? 'font-weight-bold' : 'text-third'">
                {{ item }}
              </span>
            </v-tab>
          </v-tabs>
        </div>

        <v-card-text class="mt-4">
          <gmap-map
            ref="gmap"
            :center="center"
            :zoom="12"
            :scrollwheel="false"
            style="width:100%; height: calc(100vh - 275px);">
    
            <gmap-marker
              v-for="(item, index) in selected.markers"
              :key="index"
              :position="item.latlng"
              :icon="item.icon"
              @click="toggleInfoWindow(item, index)">
            </gmap-marker>

            <gmap-info-window
              :options="infoOptions"
              :position="infoWindowPos"
              :opened="infoWinOpen"
              @closeclick="infoWinOpen=false">
              <div v-html="infoContent"></div>
            </gmap-info-window>
          </gmap-map>
        </v-card-text>
      </v-card>
    </v-dialog>

    <v-row>
      <v-col cols="12">
        <v-card flat style="border: 1px solid #E0E0E0;">
          <v-card-text>
            <v-row justify="end">
              <v-col cols="12" md="9" class="d-flex align-center">
                <div>
                  <v-btn
                    elevation="0"
                    dark
                    color="#00ACC1"
                    class="body-2 text-capitalize font-weight-bold d-flex align-center"
                    @click="dialog.filter = true">
                    <v-icon size="18">mdi-filter-outline</v-icon>

                    <span class="ml-1">
                      Filter
                    </span>
                  </v-btn>
                </div>

                <div class="ml-3">
                  <v-btn
                    elevation="0"
                    style="background: #00acc133;"
                    class="body-2 text-capitalize font-weight-bold d-flex align-center cyan--text text-darken-1"
                    @click="reset('hadir')">
                    <v-icon size="18">mdi-account-multiple-check-outline</v-icon>

                    <span class="ml-1">
                      Hadir
                    </span>
                  </v-btn>
                </div>

                <div class="ml-3">
                  <v-btn
                    elevation="0"
                    style="background: #f4403433;"
                    class="body-2 text-capitalize font-weight-bold d-flex align-center red--text"
                    @click="reset('ijin')">
                    <v-icon size="18">mdi-account-remove-outline</v-icon>

                    <span class="ml-1">
                      Ijin
                    </span>
                  </v-btn>
                </div>

                <div class="ml-3">
                  <v-btn
                    elevation="0"
                    style="background: #ff980033;"
                    class="body-2 text-capitalize font-weight-bold d-flex align-center orange--text"
                    @click="reset('pulang')">
                    <v-icon size="18">mdi-account-arrow-right-outline</v-icon>

                    <span class="ml-1">
                      Pulang
                    </span>
                  </v-btn>
                </div>
              </v-col>

              <v-col cols="12" md="3" class="d-flex align-center">
                <v-text-field
                  dense
                  single-line
                  hide-details
                  color="#00ACC1"
                  placeholder="Cari . . ."
                  append-icon="mdi-magnify"
                  clearable
                  v-model="search.name"
                  @click:clear="search.name = ''; fetch();"
                  v-on:keyup.enter="fetch()">
                </v-text-field>

                <div class="ml-3" v-if="pagination.data.total_data > 0">
                  <v-tooltip top>
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                        color="#00ACC1"
                        elevation="0"
                        min-width="36"
                        class="text-capitalize white--text px-0"
                        :disabled="process.print"
                        :loading="process.print"
                        @click="prints()"
                        v-bind="attrs"
                        v-on="on">
                        <v-icon>mdi-microsoft-excel</v-icon>
                      </v-btn>
                    </template>
                    
                    <span>
                      Print
                    </span>
                  </v-tooltip>
                </div>
              </v-col>
            </v-row>
          </v-card-text>
          
          <v-data-table
            v-model="selected.row"
            ref="table-grid"
            class="table-grid-attendance text-capitalize"
            :height="`calc(100vh - ${pagination.data.total_data > 0 ? '300px' : '228px'})`"
            fixed-header
            :loading="process.load"
            loading-text="Sedang memuat data . . ."
            loader-height="5"
            no-results-text="Belum ada data"
            :options.sync="options"
            :headers="headers"
            :items="list.data"
            :items-per-page="100"
            item-key="id"
            @click:row="rowClick"
            @toggle-select-all="handleToggleAll($event)"
            hide-default-footer>
            <template v-slot:[`item.date`]="{ item }">
              {{ item.date | date }}
            </template>

            <template v-slot:[`item.start_datetime`]="{ item }">
              {{ item.start_datetime | datetime }}
            </template>

            <template v-slot:[`item.end_datetime`]="{ item }">
              {{ item.end_datetime | datetime }}
            </template>

            <template v-slot:[`item.status`]="{ item }">
              <span :class="item.status === 'hadir' ? 'cyan--text text-darken-1' : item.status === 'ijin' || item.status === 'izin' ? 'blue--text' : 'red--text'"
                class="font-weight-bold">
                {{ item.status }}
              </span>
            </template>

            <template v-slot:[`item.start_image_url`]="{ item }">
              <v-btn v-if="item.status !== 'ijin' && item.status !== 'izin'"
                outlined
                small
                color="cyan darken-1"
                class="text-capitalize"
                @click="dialog.attachment = true; selected.detail = item; selected.menu = 0;">
                <v-icon small class="mr-1">mdi-eye-outline</v-icon>
                Lampiran
              </v-btn>
            </template>

            <template v-slot:[`item.start_location_jsonobject`]="{ item }">
              <v-btn v-if="item.status !== 'ijin' && item.status !== 'izin'"
                outlined
                small
                color="cyan darken-1"
                class="text-capitalize"
                @click="dialog.location = true; selected.detail = item; selected.menu = 0;">
                <v-icon small class="mr-1">mdi-map-marker-radius-outline</v-icon>
                Lokasi
              </v-btn>
            </template>
          </v-data-table>

          <pagination v-if="pagination.data.total_data > 0"
            @changePage="fetch($event)" 
            @reloadPage="fetch($event)"
            :model="pagination.data"/>
        </v-card>
      </v-col>
    </v-row>
  </div>
</template>

<script>
  import { get, post, put, destroy } from "../../../service/Axios";
  import { TokenService } from "../../../service/Storage.Service";
  import axios from "axios";
  import moment from 'moment';
  import 'moment/locale/id';
  export default {
    data () {
      return {
        dialog: {
          form: false,
          snackbar: false,
          filter: false,
          attachment: false,
          location: false
        },
        search: {
          name: '',
          filter: {
            date: {
              start: '',
              end: ''
            },
            start_time: '',
            end_time: ''
          },
          picker: {
            date: {
              start: false,
              end: false
            },
            start_time: false,
            end_time: false
          }
        },
        menu: ['Datang', 'Pulang'],
        menu_filter: [
          {
            text: 'Range Waktu (Datang - Pulang)',
            value: 0
          },
          {
            text: 'Range Waktu Datang',
            value: 1
          },
          {
            text: 'Range Waktu Pulang',
            value: 2
          }
        ],
        selected: {
          menu: 0,
          menu_filter: 0,
          row: [],
          attendance: '',
          detail: {},
          markers: []
        },
        center: {
          lat: -7.7400, 
          lng: 110.6646
        },
        infoContent: '',
        infoWindowPos: {
          lat: 0,
          lng: 0
        },
        infoWinOpen: false,
        currentMidx: null,
        infoOptions: {
          pixelOffset: {
            width: 15,
            height: -10
          }
        },
        options: {},
        headers: [],
        list: {
          data: [],
          user: []
        },
        pagination: {
          data: {}
        },
        limit: 20,
        picker: {
          date: false,
          time: false
        },
        form: {
          id: '',
          user_id: '',
          date: '',
          time:'',
          start_datetime: moment().format('YYYY-MM-DD HH:mm'),
          end_datetime: moment().format('YYYY-MM-DD HH:mm'),
          leave_reason: ''
        },
        process: {
          load: false,
          form: false,
          user: false,
          print: false
        },
        message: {
          error: '',
          success: ''
        }
      }
    },
    components: {
      pagination: () => import(/* webpackPrefetch: true */ '@/components/pagination.vue')
    },
    computed: {
      rps() {
        return this.$vuetify.breakpoint.name
      },
      totop() {
        let table = this.$refs['table-grid']
        let wrapper = table.$el.querySelector('div.v-data-table__wrapper')
        
        this.$vuetify.goTo(table, { container: wrapper })
      }
    },
    watch: {
      options: {
        handler () {
          let pagination = { row: this.limit, page: 1 }
          this.fetch(pagination)
        },
        deep: true
      },
      'form.id': function (val) {
        let data = this.list.user
        for (let i in data) {
          if (data[i].id === val) {
            this.form.user_id = data[i].user_id
          }
        }
      },
      'selected.detail': function (val) {
        if (Object.keys(val).length > 0) {
          this.selected.markers = []

          this.insertMarker(val)
        }
      },
      'selected.menu': function () {
        this.selected.markers = []

        this.insertMarker(this.selected.detail)
      }
    },
    mounted () {
      this.fetch()
    },
    methods: {
      rowClick (item, row) {
        row.select(!row.isSelected ? true : false)
      },
      handleToggleAll(event) {
        if (!event.value) this.selected.row = []
      },
      async fetch(pagination = { row: 20, page: 1 }) {
        this.process.load = true

        this.limit = pagination.row

        let SORT = this.options.sortBy.length < 1 ? '-id' : this.options.sortDesc[0] ? `-${this.options.sortBy[0]}` : this.options.sortBy[0]

        let range_datetime = {}

        if (this.selected.menu_filter === 0) {
          range_datetime = {
            'date[gte]': this.search.filter.date.start,
            'date[lte]': this.search.filter.date.end,
            'start_datetime[gte]': this.search.filter.start_time !== '' && this.search.filter.start_time !== null ? `${this.search.filter.date.start} ${this.search.filter.start_time}:00` : '',
            'end_datetime[lte]': this.search.filter.end_time !== '' && this.search.filter.end_time !== null ? `${this.search.filter.date.end} ${this.search.filter.end_time}:00` : ''
          }
        } else if (this.selected.menu_filter === 1) {
          range_datetime = {
            'date[gte]': this.search.filter.date.start,
            'date[lte]': this.search.filter.date.end,
            'start_datetime[gte]': this.search.filter.start_time !== '' && this.search.filter.start_time !== null ? `${this.search.filter.date.start} ${this.search.filter.start_time}:00` : '',
            'start_datetime[lte]': this.search.filter.end_time !== '' && this.search.filter.end_time !== null ? `${this.search.filter.date.end} ${this.search.filter.end_time}:00` : ''
          }
        } else {
          range_datetime = {
            'date[gte]': this.search.filter.date.start,
            'date[lte]': this.search.filter.date.end,
            'end_datetime[gte]': this.search.filter.start_time !== '' && this.search.filter.start_time !== null ? `${this.search.filter.date.start} ${this.search.filter.start_time}:00` : '',
            'end_datetime[lte]': this.search.filter.end_time !== '' && this.search.filter.end_time !== null ? `${this.search.filter.date.end} ${this.search.filter.end_time}:00` : ''
          }
        }

        let params = {
          limit: pagination.row,
          page: pagination.page,
          sort: SORT,
          search: this.search.name
        }

        params = Object.assign(range_datetime, params)


        await get(`admin/attended`, { params }).then(response => {
          let res = response.data

          this.process.load = false

          if (res.status === 200) {
            this.headers = [
              {
                text: 'Nama Lengkap',
                width: '200px',
                value: 'user_name'
              },
              {
                text: 'Status Kehadiran',
                width: '150px',
                value: 'status'
              },
              {
                text: 'Tanggal',
                width: '150px',
                value: 'date'
              },
              {
                text: 'Waktu Datang',
                width: '200px',
                value: 'start_datetime'
              },
              {
                text: 'Jarak Datang',
                width: '130px',
                value: 'start_range'
              },
              {
                text: 'Waktu Pulang',
                width: '200px',
                value: 'end_datetime'
              },
              {
                text: 'Jarak Pulang',
                width: '130px',
                value: 'end_range'
              },
              {
                text: 'Alasan Ijin',
                width: '400px',
                value: 'leave_reason'
              },
              {
                text: 'Lampiran',
                width: '100px',
                value: 'start_image_url'
              },
              {
                text: 'Lokasi',
                width: '100px',
                value: 'start_location_jsonobject'
              }
            ]
            
            this.list.data = res.results.data
            this.pagination.data = res.results.pagination
            
            this.$vuetify.goTo(this.$refs['table-grid'], { container: this.$refs['table-grid'].$el.querySelector('div.v-data-table__wrapper') })
          }
        })
      },
      async fetchUser() {
        this.process.user = true

        let params = {
          limit: 1000000,
          sort: '-id'
        }

        await get(`admin/user`, { params }).then(response => {
          let res = response.data

          this.process.user = false

          if (res.status === 200) {
            this.list.user = res.results.data
          }
        })
      },
      async fetchAttendance() {
        this.process.user = true

        let params = {
          limit: 1000000,
          sort: '-id',
          end_bool: false
        }

        await get(`admin/attended`, { params }).then(response => {
          let res = response.data

          this.process.user = false

          if (res.status === 200) {
            this.list.user = res.results.data
          }
        })
      },
      reset(type) {
        if (this.$refs.form) this.$refs.form.reset()

        this.dialog.form = !this.dialog.form ? true : false

        if (this.dialog.form) {
          if (type !== 'pulang') {
            this.fetchUser()
          } else {
            this.fetchAttendance()
          }
        }

        this.selected.attendance = type

        this.form = {
          id: '',
          user_id: '',
          date: '',
          time:'',
          start_datetime: moment().format('YYYY-MM-DD HH:mm'),
          end_datetime: moment().format('YYYY-MM-DD HH:mm'),
          leave_reason: ''
        }

        this.process.form = false

        this.message.error = ''
      },
      async save() {
        this.message.error = ''

        const isValid = await this.$refs.form.validate()
        if (isValid) {
          let url = this.selected.attendance === 'hadir' ? `admin/attended/masuk` : 
                    this.selected.attendance === 'ijin' ? `admin/attended/leave` : `admin/attended/pulang`
          
          this.process.form = true

          this.form.start_datetime = `${this.form.date} ${this.form.time}`
          this.form.end_datetime = `${this.form.date} ${this.form.time}`
          
          await post(url, {
            data: this.form
          }).then(response => {
            let res = response.data
            if (res.status === 200) {
              this.dialog.snackbar = true
              this.message.success = res.message

              this.reset()
              this.fetch()
            } else {
              this.process.form = false
              this.message.error = res.message
            }
          })
        }
      },
      async prints () {
        this.message.error = ''

        this.process.print = true

        let SORT = this.options.sortBy.length < 1 ? '-id' : this.options.sortDesc[0] ? `-${this.options.sortBy[0]}` : this.options.sortBy[0]

        let range_datetime = {}

        if (this.selected.menu_filter === 0) {
          range_datetime = {
            'date[gte]': this.search.filter.date.start,
            'date[lte]': this.search.filter.date.end,
            'start_datetime[gte]': this.search.filter.start_time !== '' && this.search.filter.start_time !== null ? `${this.search.filter.date.start} ${this.search.filter.start_time}:00` : '',
            'end_datetime[lte]': this.search.filter.end_time !== '' && this.search.filter.end_time !== null ? `${this.search.filter.date.end} ${this.search.filter.end_time}:00` : ''
          }
        } else if (this.selected.menu_filter === 1) {
          range_datetime = {
            'date[gte]': this.search.filter.date.start,
            'date[lte]': this.search.filter.date.end,
            'start_datetime[gte]': this.search.filter.start_time !== '' && this.search.filter.start_time !== null ? `${this.search.filter.date.start} ${this.search.filter.start_time}:00` : '',
            'start_datetime[lte]': this.search.filter.end_time !== '' && this.search.filter.end_time !== null ? `${this.search.filter.date.end} ${this.search.filter.end_time}:00` : ''
          }
        } else {
          range_datetime = {
            'date[gte]': this.search.filter.date.start,
            'date[lte]': this.search.filter.date.end,
            'end_datetime[gte]': this.search.filter.start_time !== '' && this.search.filter.start_time !== null ? `${this.search.filter.date.start} ${this.search.filter.start_time}:00` : '',
            'end_datetime[lte]': this.search.filter.end_time !== '' && this.search.filter.end_time !== null ? `${this.search.filter.date.end} ${this.search.filter.end_time}:00` : ''
          }
        }

        let params = {
          sort: SORT,
          search: this.search.name
        }

        params = Object.assign(range_datetime, params)

        await axios({
          url: `${process.env.VUE_APP_API_URL}admin/attended/export`,
          method: 'GET',
          responseType: 'blob', // important,
          params: params,
          headers: {
            Authorization: process.env.VUE_APP_XAUTH,
            token: TokenService.getToken()
          }
        }).then((response) => {
          let res = response
          if (res.status === 200) {
            this.process.print = false
            
            this.dialog.snackbar = true
            this.message.success = 'Berhasil mengeksport excel'

            const url = window.URL.createObjectURL(new Blob([response.data]))
            const link = document.createElement('a')
            link.href = url
            link.setAttribute('download', `AMJ-ABSENSI-${moment().format('DD-MMMM-YYYY', 'id')}.xls`)
            document.body.appendChild(link)
            link.click()
          } else {
            this.process.print = false
            this.message.error = res.message
          }
        })
      },
      insertMarker(data) {
        this.$gmapApiPromiseLazy().then(() => {
          this.selected.markers.push({
            id: data.user_id,
            name: data.user_name,
            email: data.user_email,
            mobilephone: data.user_mobilephone,
            role: data.user_role,
            position: data.user_position,
            address: data.user_address,
            image_url: data.user_image_url,
            latlng: {
              lat: parseFloat(this.selected.menu < 1 ? data.start_location_jsonobject.latitude : data.end_location_jsonobject.latitude), 
              lng: parseFloat(this.selected.menu < 1 ? data.start_location_jsonobject.longitude : data.end_location_jsonobject.longitude)
            },
            icon: {
              url: require('@/assets/image/marker.png'),
              scaledSize: new google.maps.Size(50, 50),
              origin: new google.maps.Point(0, 0),
              anchor: new google.maps.Point(10, 10)
            }
          })
        })

        this.center = this.selected.markers.length > 0 ? this.selected.markers[0].latlng : this.center
      },
      toggleInfoWindow(marker, idx) {
        this.infoWindowPos = marker.latlng
        this.infoContent = this.getInfoWindowContent(marker)
        
        if (this.currentMidx == idx) {
          this.infoWinOpen = !this.infoWinOpen
        } else {
          this.infoWinOpen = true
          this.currentMidx = idx
        }
      },
      getInfoWindowContent(marker) {
        let data = marker

        return (`
          <div id="iw-container">
            <div class="iw-title">
              Lokasi Terakhir
            </div>

            <div class="iw-content">
              <img 
                class="image"
                height="100" 
                width="100"
                src="${data.image_url}">

              <div class="iw-subTitle">
                ${data.name}
              </div>

              <p style="margin-bottom: 2px; opacity: 50%;">
                Email
              </p>

              <p style="margin-bottom: 6px; font-weight: bold;">
                ${data.email}
              </p>

              <p style="margin-bottom: 2px; opacity: 50%;">
                Telepon
              </p>

              <p style="margin-bottom: 6px; font-weight: bold;">
                ${data.mobilephone}
              </p>

              <p style="margin-bottom: 2px; opacity: 50%;">
                Role (Posisi)
              </p>

              <p style="margin-bottom: 12px; font-weight: bold; text-transform: capitalize;">
                ${data.role} (${data.position})
              </p>

              <p style="margin-bottom: 2px; font-weight: bold;">
                <a href="/user/${data.id}" target="_blank">
                  Lihat Detail . . .
                </a>
              </p>
            </div>
          </div>
        `)
      }
    }
  }
</script>

<style>
  .table-grid-attendance table > thead > tr > th:nth-child(1) {
    position: sticky !important; 
    position: -webkit-sticky !important; 
    left: 0; 
    z-index: 5 !important;
    background: white;
  }
  .table-grid-attendance table > thead > tr > th:nth-child(2) {
    position: sticky !important; 
    position: -webkit-sticky !important; 
    left: 200px; 
    z-index: 5 !important;
    background: white;
  }
  .table-grid-attendance table > tbody > tr > td:nth-child(1) {
    position: sticky !important; 
    position: -webkit-sticky !important; 
    left: 0; 
    z-index: 1;
    background: white;
  }
  .table-grid-attendance table > tbody > tr > td:nth-child(2) {
    position: sticky !important; 
    position: -webkit-sticky !important; 
    left: 200px; 
    z-index: 1;
    background: white;
  }
</style>